var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table"},[_c('Grid',{style:({'margin':'0 auto'}),attrs:{"data-items":_vm.items,"filterable":true,"filter":_vm.filter,"sortable":true,"sort":_vm.sort,"columns":_vm.columns},on:{"filterchange":_vm.filterChange,"sortchange":_vm.sortChangeHandler},scopedSlots:_vm._u([{key:"filterSlotTemplate",fn:function(ref){
var props = ref.props;
var methods = ref.methods;
return [_c('div',{staticClass:"k-filtercell"},[_c('div',{staticClass:"k-filtercell-wrapper"},[_c('input',{staticClass:"k-textbox",attrs:{"type":"text","placeholder":"search"},domProps:{"value":props.value},on:{"input":function (ev) {
                          methods.change(
                            {
                              operator: 'contains',
                              field: props.field,
                              value: ev.target.value,
                              syntheticEvent: ev
                            }
                          );
                        }}})])])]}},{key:"filterIsEqualTemplate",fn:function(ref){
                        var props = ref.props;
                        var methods = ref.methods;
return [_c('div',{staticClass:"k-filtercell"},[_c('div',{staticClass:"k-filtercell-wrapper"},[_c('input',{staticClass:"k-textbox",attrs:{"type":"text","placeholder":"filter"},domProps:{"value":props.value},on:{"input":function (ev) {
                          methods.change(
                            {
                              operator: 'eq',
                              field: props.field,
                              value: ev.target.value,
                              syntheticEvent: ev
                            }
                          );
                        }}})])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }